import { Game } from '../models/Game'
import { Http } from '../utils/Http'

export class GameStatistic extends Game {
  public static readonly classPath = 'rally-round'

  totalPosts = 0
  ratedPosts = 0

  async getStatisticForRallyRound (rallyRoundId: number) {
    const statistic = await Http.request(`/api/rally-round/${rallyRoundId}/challenges/${this.id}/statistic`)
    const data = await statistic.json()
    this.totalPosts = data.totalPosts
    this.ratedPosts = data.ratedPosts

    // can happen if posts have been rated that were not upload_finished (was possible before)
    if (this.ratedPosts > this.totalPosts) {
      this.ratedPosts = this.totalPosts
    }
  }
}
